import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f1179c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "app-toggle"
}
const _hoisted_2 = { class: "checkbox__text" }
const _hoisted_3 = ["id", "checked"]
const _hoisted_4 = ["for"]
const _hoisted_5 = {
  key: 1,
  class: "d-app-toggle"
}
const _hoisted_6 = { class: "d-checkbox__text" }
const _hoisted_7 = ["id", "checked"]
const _hoisted_8 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        _createElementVNode("input", _mergeProps({
          type: "checkbox",
          id: _ctx.props.id
        }, _ctx.$attrs, { checked: _ctx.checked }), null, 16, _hoisted_3),
        _createElementVNode("label", {
          for: _ctx.props.id
        }, "Toggle", 8, _hoisted_4)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        _createElementVNode("input", _mergeProps({
          type: "checkbox",
          id: _ctx.props.id
        }, _ctx.$attrs, { checked: _ctx.checked }), null, 16, _hoisted_7),
        _createElementVNode("label", {
          for: _ctx.props.id
        }, "Toggle", 8, _hoisted_8)
      ]))
}